import { closeAriaCombobox } from './aria-combobox-close';
import type { Combobox } from '@angular/aria/combobox';

const COMBOBOX_OPEN_KEYS = new Set(['Enter', ' ', 'ArrowDown', 'ArrowUp']);

/**
 * Gestione tastiera sul trigger del combobox readonly.
 * Con popup chiuso apre senza propagare (evita doppio step ngCombobox).
 * Con popup aperto lascia frecce/Enter/Space a ngCombobox.
 */
export function handleAriaReadonlyComboboxTriggerKeydown(
  event: KeyboardEvent,
  combobox: Combobox<unknown> | undefined,
  isDisabled: boolean
): void {
  if (isDisabled || !combobox) {
    return;
  }

  if (combobox.expanded()) {
    if (event.key === 'Escape') {
      event.preventDefault();
      closeAriaCombobox(combobox);
    }
    return;
  }

  if (COMBOBOX_OPEN_KEYS.has(event.key)) {
    event.preventDefault();
    event.stopPropagation();
    combobox.open();
  }
}
